import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ButtonModule } from 'primeng/button';
import { EmployeModule } from './components/employe/employe.module';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SigninComponent } from './login/signin/signin.component';
import { SignupComponent } from './login/signup/signup.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AppRoutingModule } from './app-routing.module';
import { FourOhFourComponentComponent } from './four-oh-four-component/four-oh-four-component.component';
import { HttpClientModule } from '@angular/common/http';
import { MarchandModule } from './components/marchand/marchand.module';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { AccountActivationComponent } from './account-activation/account-activation.component';
import { FirstLoginChangePasswordComponent } from './features/auth/first-login-change-password/first-login-change-password.component';
@NgModule({
  declarations: [
    AppComponent,

    SigninComponent,
    SignupComponent,
    LandingPageComponent,
    FourOhFourComponentComponent,
    InvoiceComponent,
    AccountActivationComponent,
    FirstLoginChangePasswordComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ButtonModule,
    EmployeModule,
    ReactiveFormsModule,
    ToastModule,
    MarchandModule,
  ],
  providers: [MessageService],
  bootstrap: [AppComponent],
})
export class AppModule {}
